module.exports = "<div ngIf=\"notams.rows\" *ngFor=\"let notam of notams\">\n\t{{notam.iteme}}\n</div>\n"